// extracted by mini-css-extract-plugin
export default {"container":"LogDataCell_container__bRkOh","iconWrapper":"LogDataCell_iconWrapper__W5cKs"};